































































import { NullableString } from "@/code/Types";
import { Component } from "vue-property-decorator";
import BasePage from "@/views/base/BasePage";
import { InForceCaseData } from "@/models/InForceCaseData";
import { inForceStore } from "@/store/modules/InForceStore";
import { Routes } from "@/router/Routes";
import { Helpers } from "@/code/Helpers";
import { InForceProductGroup } from "@/enums/InForceProductGroup";

@Component
export default class extends BasePage {
  search: NullableString = null;

  headers = [
    { text: "Insured Name", value: "insuredFullName" },
    { text: "Product Group", value: "productGroup" },
    { text: "Carrier", value: "insuranceCompany" },
    { text: "Product", value: "productName" },
    { text: "Face", value: "faceAmount" },
    { text: "Premium", value: "annualizedPremiumAtIssue" },
    {
      text: "Effective Date",
      value: "effectiveDate",
      sort: (a: NullableString, b: NullableString): number =>
        Helpers.sortDate(a, b),
    },
    { text: "Notifications", value: "notificationCount", align: "center" },
  ];

  get allCases(): InForceCaseData[] {
    return inForceStore.entities;
  }
  async bookOfBusiness(): Promise<void> {
    await this.$router.push({ name: Routes.EXISTING_BUSINESS });
  }
  async selectPolicy(id: string, productGroup: string): Promise<void> {
    if (productGroup === InForceProductGroup.LIFE) {
      await this.$router.push({
        name: Routes.INFORCE_LIFE_DETAIL,
        params: { id },
      });
    } else if (productGroup === InForceProductGroup.ANNUITY) {
      await this.$router.push({
        name: Routes.INFORCE_ANNUITY_DETAIL,
        params: { id },
      });
    }
  }
}
